import Axios from 'axios'
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { getUser } from '../../../../actions/session'
import {
    CARRIER_RATEDECK_CANCEL,
    CARRIER_RATEDECK_DOWNLOAD,
    CARRIER_RATEDECK_LIST,
    LOGIN_URL
} from '../../../../config/rest_endpoints'
import CustomLoader from '../../../common/loader'
import CustomModal from '../../../common/modal'
import { Notifications } from '../../../common/notification'
import AddRateDeckCarrier from './addRateDeckCarrier'
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';


export default class RateDeckTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list :[],
            User:getUser(),
            userId: this.props.userId,
            isGetting:false,
            isUploadModal:false,
            isDataTable:false,
            clearState:false
        }
        this.openUploadModal = this.openUploadModal.bind(this)
        this.closeUploadModal = this.closeUploadModal.bind(this)
        this.getList = this.getList.bind(this)
    }

    componentDidMount() {
        this.getList()
    }

    openUploadModal() {
        this.setState({isUploadModal:true})
    }

    closeUploadModal() {
            
            this.setState({isUploadModal:false,  isDataTable:false,clearState:true},()=>{
            this.getList()
        })
    }

    getList() {
        var headers = { 'Authorization': "Bearer " + this.state.User.token }
        this.setState({isGetting:true})
        Axios.get(`${CARRIER_RATEDECK_LIST}/${this.state.userId}/ratedeck`,{headers}).then(res =>{
            if(res) {
                console.log(`res`, res)
                var resp = res.data.data
                this.setState({
                    list :resp,
                    isGetting:false,
                    clearState:false
                })
            }
        }).catch(err =>{
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
            })
        })
    }

    rateDeckDownload(name,id,type) {
        const { User } = this.state
        var headers = { 'Authorization': "Bearer " + User.token }
        const URL = type === 'original' ? `${CARRIER_RATEDECK_DOWNLOAD}?file=${name}` : `${CARRIER_RATEDECK_DOWNLOAD}?file=${id}`
        Axios.get(URL, { headers }).then(res => {
            let content = res.headers['content-disposition']
            if (res) {
                var resp = res.data
                var short = content.split("filename=")[1]
                var filename = short.replace(/['"]+/g, '')
                const url = window.URL.createObjectURL(new Blob([resp])) 
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${filename}.csv`)
                document.body.appendChild(link)
                link.click()
              
            }
            else {
                this.setState({ msg: '', isError: true, isGetting:false })
                Notifications.notify("Failed to created", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    rateDeckCancel(id) {
        const { User } = this.state
        var headers = { 'Authorization': "Bearer " + User.token }
        const data = {
            ratedeckID:id
        }
        Axios.post(`${CARRIER_RATEDECK_CANCEL}?file=${id}`,data, { headers }).then(res => {
            if (res) {
                console.log(`res`, res)
                this.getList()
            }
            else {
                this.setState({ msg: '', isError: true, isGetting:false })
                Notifications.notify("Failed to created", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    renderTableList() {
        const { list } = this.state
        console.log(`list`, list)
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if ( list === null || list.length == 0 ) {
            return nullData
        }
        else {
          return list.map((row,idx)=>{
              return (
                  <tr key={idx}>
                      <td style={{textAlign:'center'}}>{row.csvName}</td>
                      <td style={{textAlign:'center'}}>{row.connectFee}</td>
                      <td style={{textAlign:'center'}}>{row.initialInc}</td>
                      <td style={{textAlign:'center'}}>{row.subsequentInc}</td>
                      <td style={{textAlign:'center'}}>{row.roundingMethod}</td>
                      <td style={{textAlign:'center'}}>{row.roundingDigits}</td>
                      <td style={{textAlign:'center'}}>{row.effectiveDate}</td>
                      <td style={{textAlign:'center'}}>{row.createDate}</td>
                      <td style={{textAlign:'center'}}>{row.status === 'pending' ? <span className="badge badge-info">Pending</span> : row.status === 'active' ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">In-active</span>}</td>
                      <td style={{textAlign:'center'}}>
                          <DropdownButton style={{ position: 'relative', display: "contents" }} size="sm"  id="dropdown-item-button"  title={<i class="icon-menu7"></i>} >
                              <Dropdown.Item as="button"  onClick={this.rateDeckDownload.bind(this, row.csvName,row.id,'system')}><i className=" edit-button icon-file-download mr-2" ></i>System Generated Ratedeck</Dropdown.Item>
                              <Dropdown.Item as="button" onClick={this.rateDeckDownload.bind(this,row.csvName, row.id,'original')}><i className="edit-button icon-file-download mr-2" ></i>Original Ratedeck </Dropdown.Item>
                              <Dropdown.Item as="button" onClick={this.rateDeckCancel.bind(this, row.id)}><i style={{fontSize:'17px'}} className="text-danger icon-stack-cancel mr-2" ></i>Cancel Ratedeck</Dropdown.Item>
                          </DropdownButton>
                      </td>
                  </tr>
              )
          })
        }
    }

    render() {
        const {isUploadModal} = this.state
        let uploadModal = {
            details: {
                info: `Add RateDeck`,
                msg: <AddRateDeckCarrier clearState={this.state.clearState} data={this.state.list} listing={this.getList} clearModal={this.state.isDataTable} id={this.state.userId} close={this.closeUploadModal}  />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeUploadModal },
            cancelBtn: { label: "Cancel", action: this.closeUploadModal }
        }
        if (this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }
        return (
            <div>
                 <CustomModal
                    visibility={isUploadModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    modalSize="large"
                    details={uploadModal.details}
                    showBtns={false}
                    cancelBtn={uploadModal.cancelBtn}
                    crossBtn={uploadModal.crossBtn}
                />
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                    <div className="card-header header-elements-inline p-0 py-1 mb-2">
                        <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                        <div className="header-elements">
                            <button  type="submit" className="main-button btn btn-success btn-sm ml-auto" onClick={this.openUploadModal} >Upload Ratedeck <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header border-0">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                            <input type="search" className="" placeholder="Type to filter..."  aria-controls="DataTables_Table_0" />
                        </label> */}
                            </div>
                        </div>
                        <div className="datatable-scroll" style={{overflowX: 'auto'}}>
                            <table style={{border:'1px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Csv Name</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Connect Fee</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Initial Inc</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Subsequent Inc</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Rounding Method</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Rounding Digits</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Effective Date</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Create Date</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Status</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isGetting ? <CustomLoader /> : this.renderTableList()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to 10 of 15 entries</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
